import { ArrowRight, Clock } from 'lucide-react';
import { useEffect, useState } from 'react';
import { pushToDataLayer } from '../utils/gtm';

export default function Hero() {
  const [headline, setHeadline] = useState<string>('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const customHeadline = params.get('headline');
    if (customHeadline) {
      setHeadline(customHeadline);
    }
  }, []);

  return (
    <section className="relative bg-gradient-to-b from-white to-green-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-24">
        {/* Headline + Subheadline */}
        <div className="text-center mb-12 lg:mb-16 max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
            {headline ? (
              <span className="block text-green-600">{headline}</span>
            ) : (
              <>
                7 Tage. 30 Minuten täglich.
                <span className="block text-green-600 mt-2">
                  Dein Körper vergisst alte Gewohnheiten – dauerhaft.
                </span>
              </>
            )}
          </h1>
          <p className="text-xl sm:text-2xl text-gray-700 leading-relaxed">
            Mehr Energie, klarer Kopf, weniger Gewicht. Ohne Verzicht.
          </p>
        </div>

        {/* Video + CTA Section */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          {/* Left Column - Video */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-video">
              <wistia-player media-id="i2noi2bvrw" aspect="1.7777777777777777"></wistia-player>
            </div>
          </div>

          {/* Right Column - CTA + Price Box */}
          <div className="space-y-6">
            {/* Price Box */}
            <div className="bg-gradient-to-br from-orange-50 to-amber-50 p-6 lg:p-8 rounded-2xl border-2 border-orange-200 shadow-lg">
              <div className="space-y-4">
                <div className="flex items-center gap-2">
                  <span className="text-3xl">⚡</span>
                  <p className="text-sm font-semibold text-gray-900 uppercase tracking-wide">
                    Limitiertes Angebot
                  </p>
                </div>

                <div className="space-y-2">
                  <div className="flex items-baseline gap-3">
                    <span className="text-5xl lg:text-6xl font-bold text-orange-600">49 €</span>
                    <span className="text-3xl line-through text-gray-500">149 €</span>
                  </div>
                  <p className="text-base text-gray-700 font-medium">
                    Nur die ersten 100 Teilnehmer
                  </p>
                </div>

                <div className="bg-white/80 backdrop-blur-sm rounded-xl p-4 border border-orange-200">
                  <p className="text-sm text-gray-700 leading-relaxed">
                    oder <span className="font-bold text-gray-900">0 €</span>, wenn du 5 kg verlierst.
                  </p>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <a
              href="https://www.digistore24.com/product/642539/siebentage5kilo/?ds24_domain=www.digistore24.com&voucher=7TageStart"
              className="group w-full bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-8 py-6 rounded-xl text-xl font-bold flex items-center justify-center gap-3 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              onClick={() => pushToDataLayer('initiate_checkout')}
            >
              Jetzt starten – Aktionspreis sichern
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" />
            </a>

            {/* Social Proof */}
            <div className="flex items-center gap-6 pt-4 border-t border-gray-200">
              <img
                src="/Gemini_Generated_Image_tne76rtne76rtne7-removebg-preview.png"
                alt="Teilnehmer Avatare"
                className="h-12 w-auto"
              />
              <div className="text-sm">
                <div className="font-semibold text-gray-900">10 000+ Teilnehmer</div>
                <div className="text-gray-600 flex items-center gap-1">
                  <span className="text-amber-500">★★★★★</span>
                  <span>4.9 Bewertung</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
